<template>
  <div class="change-word">
    <van-nav-bar
      title="修改密码"
      left-arrow
      @click-left="onClickLeft"
    ></van-nav-bar>
    <van-field
      v-model="oldPassword"
      :type="isShowOld ? 'password' : 'text'"
      label="原密码"
      :right-icon="!isShowOld?'eye-o':'closed-eye'"
      placeholder="请输入密码"
      @click-right-icon="isShowOld = !isShowOld"
      required
    ></van-field>
    <van-field
      v-model="newPassword"
      :type="isShowNew ? 'password' : 'text'"
      label="新密码"
      :right-icon="!isShowNew?'eye-o':'closed-eye'"
      placeholder="请输入密码"
      @click-right-icon="isShowNew = !isShowNew"
      required
    ></van-field>
    <van-field
      v-model="rPassword"
      :type="isShowR ? 'password' : 'text'"
      label="重复密码"
      :right-icon="!isShowR?'eye-o':'closed-eye'"
      placeholder="请输入密码"
      @click-right-icon="isShowR = !isShowR"
      required
    ></van-field>
    <van-button style="margin-top: 30px" type="info" size="large" @click="changePassword">修改</van-button>
  </div>
</template>
<script>
  export default {
    name: 'changePassword',
    data() {
      return {
        isShowOld: true,
        isShowNew: true,
        isShowR: true,
        oldPassword: '',
        newPassword: '',
        rPassword: '',
      }
    },
    created() {

    },
    methods: {
      onClickLeft() {
        this.$router.back();
      },
      async changePassword() {
        let params = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          newConfirmPassword: this.rPassword,
        }

        let res = await this.xyapi.post(this.xyMApi + '/base/api/Users/ChangeUsersPassword', params);
        if (res.success) {
          this.xy.msgSuc('修改成功')
        }

      }
    },
  }
</script>
<style lang="less" scoped>

</style>
